import React, { useEffect } from 'react';

const AdSenseSidebarAd: React.FC = () => {
  useEffect(() => {
    try {
      // @ts-ignore
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: 'inline-block', width: '160px', height: '600px' }}
      data-ad-client="ca-pub-4910046262930409"
      data-ad-slot="8050805789"
    ></ins>
  );
};

export default AdSenseSidebarAd; 